import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { doImpersonate } from "../../actions/auth";
import { fetchImpersonateOptions } from "../../actions/users";
import { AsyncSelectWrapper } from "../app/SelectWrapper";

class ImpersonateModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
  };

  state = {
    user: null,
  };

  selectUser = (user) => {
    this.setState({ user });
  };

  impersonate = () => {
    const user = { id: this.state.user.value };
    this.props.dispatch(doImpersonate(user));
    this.setState({ user: null });
  };

  render() {
    return (
      <div
        id="ImpersonateModal"
        aria-labelledby="ImpersonateModal-title"
        className="modal fade modal-fade-in-scale-up"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title" id="ImpersonateModal-title">
                Select user to impersonate
              </h4>
            </div>
            <div className="modal-body">
              <div className="app-form-group form-material app-layout-row">
                <div className="app-col-sm-12">
                  <AsyncSelectWrapper
                    placeholder="User"
                    className="app-form-control"
                    loadOptions={fetchImpersonateOptions}
                    value={this.state.user}
                    onChange={this.selectUser}
                  />
                </div>
              </div>
              {this.state.user && (
                <div className="app-form-group form-material app-layout-row">
                  <div className="app-col-sm-12">
                    <button
                      onClick={this.impersonate}
                      type="button"
                      className="app-btn btn-round app-btn--info waves-effect waves-light"
                    >
                      Impersonate
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(ImpersonateModal);
